import * as React from 'react';

const HomeIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    {...props}
  >
    <rect width="58" height="56.4037" rx="28.2018" fill="#E5F1FF" />
    <mask
      id="mask0"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="11"
      width="33"
      height="34"
    >
      <rect x="12.4699" y="11.9609" width="32.48" height="32.48" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M18.56 40.0678V27.1816L16.033 29.1755L14.8123 27.5111L18.56 24.5511V20.5581H20.59V22.9507L28.71 16.584L42.6077 27.5111L41.387 29.1543L38.86 27.1816V40.0678H30.3235V31.8784H27.0965V40.0678H18.56Z"
        fill="#003594"
      />
    </g>
  </svg>
);

export default HomeIcon;
